import React, { useState } from "react";
import {
  Nav,
  NavbarBrand,
  NavItem,
  NavLink,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Navbar,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

function CourseAdminNav({ location, table }) {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const headingTitle = () => {
    switch (location) {
      case "courses":
        return "Kurser";
      case "modules":
        return "Moduler";
      case "licenses":
        return "Licenser";
      case undefined:
        if (table === "studGrade") {
          return "Kursbetyg - Studentkommentarer";
        } else if (table === "moduleGrade") {
          return "Kursbetyg - Modulbetyg";
        }
        break;
      default:
        return "";
    }
  };

  return (
    <Navbar
      container={false}
      color="primary"
      dark
      expand="md"
      className="px-3"
    >
      <NavbarBrand>{headingTitle()}</NavbarBrand>
      <Nav className="ms-auto" navbar>
        <NavItem>
          <NavLink
            href="#"
            onClick={() => navigate("/superuser/courses")}
            title="Alla kurser"
            disabled={location === "courses"}
            active={location === "courses"}
          >
            Kurser
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            onClick={() =>
              navigate("/superuser/courses/modules")
            }
            disabled={location === "modules"}
            active={location === "modules"}
            title="Alla moduler"
          >
            Moduler
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            onClick={() =>
              navigate("/superuser/courses/licenses")
            }
            disabled={location === "licenses"}
            active={location === "licenses"}
            title="Licenser"
          >
            Licenser
          </NavLink>
        </NavItem>
        <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
          <DropdownToggle nav caret id="courseAdmin--Dropdown-toggler">
            Kursbetyg
          </DropdownToggle>
          <DropdownMenu className="mt-2" id="courseAdmin--Dropdown-menu">
            <DropdownItem
              tag="span"
              disabled={table === "studGrade"}
              active={table === "studGrade"}
              className="courseAdmin--Dropdown-item"
            >
              <Link
                to="/superuser/courses/ratings"
                state={{ table: "studGrade" }}
                replace
                className="courseAdminNav--Dropdown-link"
              >
                Studentkommentarer
              </Link>
            </DropdownItem>
            <DropdownItem
              tag="span"
              disabled={table === "moduleGrade"}
              active={table === "moduleGrade"}
              className="courseAdmin--Dropdown-item"
            >
              <Link
                to="/superuser/courses/ratings"
                state={{ table: "moduleGrade" }}
                replace
                className="courseAdminNav--Dropdown-link"
              >
                Modulbetyg
              </Link>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Nav>
    </Navbar>
  );
}

export default CourseAdminNav;
